<template>
    <section class="tickets">
        <div class="level m-t-md m-b-md">
            <div class="level-left">
                <div class="level-item">
                    <span class="title">Log Support Ticket</span>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <div class="columns">
                            <div class="column is-half">
                                <b-field horizontal>
                                    <template #label>
                                        Type <span class="has-text-danger">*</span>
                                    </template>
                                    <b-select v-model="data.type" id="select-type" expanded>
                                        <option :value="null">Please Select</option>
                                        <option
                                            v-for="(type, index) in types"
                                            :key="index"
                                            :value="type"
                                        >{{ type }}</option>
                                    </b-select>
                                </b-field>

                                <b-field v-show="apps.length>1" horizontal>
                                    <template #label>
                                        App <span class="has-text-danger">*</span>
                                    </template>
                                    <app-filter v-model="data.app_id" expanded placeholder="Select app"></app-filter>
                                    <!-- <b-select v-model="data.app_id" id="select-app" expanded>
                                        <option :value="null">Please Select</option>
                                        <option
                                            v-for="(app,key) in apps"
                                            :key="key"
                                            :value="app.id"
                                        >{{ app.name }}</option>
                                    </b-select> -->
                                </b-field>

                                <b-field horizontal>
                                    <template #label>
                                        Priority <span class="has-text-danger">*</span>
                                    </template>
                                    <b-select v-model="data.priority" id="select-priority" expanded>
                                        <option :value="null">Please Select</option>
                                        <option
                                            v-for="(priority, index) in priorities"
                                            :key="index"
                                            :value="priority"
                                        >{{ priority }}</option>
                                    </b-select>
                                </b-field>

                                <b-field horizontal>
                                    <template #label>
                                        Details <span class="has-text-danger">*</span>
                                    </template>
                                    <b-input type="textarea" v-model="data.details" id="input-details"></b-input>
                                </b-field>
                                <b-field label="Location" horizontal>
                                    <b-field>
                                        <b-checkbox-button type="is-dark" v-model="selectedEnvironment" native-value="production">
                                            Production
                                        </b-checkbox-button>
                                        <b-checkbox-button type="is-dark" v-model="selectedEnvironment" native-value="test">
                                            Test
                                        </b-checkbox-button>
                                    </b-field>
                                </b-field>

                                <b-field label="Reference" horizontal>
                                    <b-input v-model="data.third_party_code" id="input-reference"></b-input>
                                </b-field>

                                <b-field label="Tags" horizontal>
                                    <b-taginput
                                        v-model="tagsSelected"
                                        ellipsis
                                        :data="filteredTags"
                                        placeholder="Add a tag"
                                        aria-close-label="Delete this tag"
                                        allow-new
                                        field="attributes.value"
                                        type="is-dark"
                                        autocomplete
                                        open-on-focus
                                        :remove-on-keys="['Backspace']"
                                        :confirm-keys='[",", "Tab", "Enter"]'
                                        @typing="getFilteredTags"
                                        :allow-duplicates="false"
                                        >
                                    </b-taginput>
                                </b-field>
                                <!-- <b-field label="Rank" v-if="isNotUser()" horizontal>
                                    <b-numberinput :editable="false" type="is-dark" v-model="data.rank" min="0" step="10" exponential controls-position="compact" expanded></b-numberinput>
                                </b-field> -->

                                <b-field label="Point" v-if="isRole('serviceperson')" horizontal>
                                    {{data.point_id}}
                                </b-field>

                                <div
                                    class="card"
                                    v-if="auth.permissions.includes('can_manage_release')"
                                >
                                    <div class="card-header has-background-light">
                                        <p class="card-header-title">Release</p>
                                    </div>
                                    <div class="card-content">
                                        <label class="label">Parent Ticket</label>
                                        <div class="field is-grouped">
                                            <b-select v-model="data.release_id" expanded>
                                                <option :value="null">Please Select</option>
                                                <option
                                                    v-for="release in releases"
                                                    :key="release.id"
                                                    :value="release.id"
                                                >{{ release.attributes.name }}</option>
                                            </b-select>
                                            <p class="control" v-if="data.release_id">
                                                <b-button @click.prevent="viewRelease">view</b-button>
                                            </p>
                                        </div>

                                        <b-field label="Release Details" horizontal>
                                            <b-input type="textarea" v-model="data.release_notes"></b-input>
                                        </b-field>

                                        <label class="label">Parent Ticket</label>
                                        <div class="field is-grouped">
                                            <b-select v-model="data.ticket_parent_id" expanded>
                                                <option :value="null">No Parent Ticket</option>
                                                <option
                                                    v-for="parent in parentTickets"
                                                    :key="parent.id"
                                                    :value="parent.id"
                                                >#{{ parent.id | makeIDSixDigits}}</option>
                                            </b-select>
                                            <p class="control" v-if="data.ticket_parent_id">
                                                <b-button @click.prevent="viewParent">view</b-button>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <section class="m-t-md">
                                    <router-link :to="{ name: 'tickets' }" class="button is-default m-r-sm">Cancel</router-link>
                                    <b-button id="btn-save" type="is-success m-r-sm" @click.prevent="save">Save</b-button>
                                </section>
                            </div>
                            <div class="column is-half">
                                <section>
                                    <files @upload="upload"></files>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import Vue from "vue";
// import Cookies from '../../../helpers/cookies';
import appFilter from '../../../components/AppFilter.vue';
import _ from 'lodash/lodash';
import files from "./_id/_includes/files";

export default {
    components:{
        files,
        appFilter
    },
    data() {
        return {
            releases: [],
            parentTickets: [],
            apps: [],
            types: ["Bug Report", "Feature Suggestion", "Service Request"],
            priorities: ["Critical", "Urgent", "Routine"],
            data: {
                type: null,
                status: "unresolved",
                priority: null,
                details: null,
                third_party_code: null,
                app_id: null,
                release_id: null,
                release_notes: null,
                ticket_parent_id: null,
                point_id:null,
                tags:[],
                rank:0,
                environment:null
                // related_ticket_ids: []
            },
            selectedEnvironment:[],
            tags:[],
            point:null,
            filteredTags:[],
            tagsSelected:[],
            files:[]
        };
    },
    watch: {
        "data.release_id"(id) {
            if (id) {
                this.getParentTicketList();
            }
        },
        "data.app_id"(id) {
            if(id) {
                this.getReleases()
            }
        },
        tagsSelected(newValue){
            this.data.tags = []
            newValue.forEach((element)=>{
                if(typeof element === 'object'){
                    this.data.tags.push({id:element.id,value:element.attributes.value})
                }else{
                    this.data.tags.push({value:element})
                }
            })
        },
        selectedEnvironment(newValue,oldValue){
            if(newValue.length<=1){
                this.data.environment = newValue[0] ? newValue[0] : null
            }else{
                this.selectedEnvironment = _.difference(newValue,oldValue)
            }
        }
    },
    computed: {
        auth: {
            get() {
                return this.$store.state.auth;
            }
        },
        loading: {
            get() {
                return this.$store.state.loading;
            },
            set(value) {
                this.$store.commit("SET_LOADING", value);
            }
        },
        referrer() {
            return document.referrer
        },
        pointId() {
            return this.$router.currentRoute.query.point ? this.$router.currentRoute.query.point : null
        },
    },
    async mounted() {
        await this.getTags()
        if(this.pointId){
            Vue.$pointService.getPoint(this.pointId).then(async (response)=>{
                this.point = response.data
                this.data.point_id = response.data.attributes.name
                this.loading = true;
                await this.getAppList();
                if(this.auth.permissions.includes('can_manage_release')){
                    await this.getReleases();
                }
            })
        }else{
            this.loading = true;
            await this.getAppList();
            if(this.auth.permissions.includes('can_manage_release')){
                await this.getReleases();
            }
        }
        this.loading=false
    },
    methods: {
        save() {
            this.loading = true;
            var isWithGatekeeper = false;
            Vue.$ticketService.createTicket(this.data).then((response) => {
                isWithGatekeeper = response.data.attributes.gatekeeper_id
                if(this.files.length){
                    return Vue.$ticketService
                    .uploadFiles(response.data.id, this.files)
                }
            }).then(()=>{
                this.$store.commit('SET_SELECTED_APP',this.data.app_id)
                localStorage.setItem('ticketStatus',JSON.stringify(['unresolved']))

                this.$buefy.toast.open({
                    type: isWithGatekeeper ? 'is-success' : 'is-warning',
                    message: isWithGatekeeper ? 'Ticket Saved' : 'Ticket saved but no Gatekeeper configured on your domain.',
                    duration: 5000

                })
                this.loading = false;
                this.$router.push({
                    name: "tickets"
                });
            })
            .catch(err => {
                this.loading = false;
                console.log(err)
            });
        },

        getReleases() {
            let params = `?status=pending&app_id=${this.data.app_id}`;
            Vue.$releaseService.releaseList(params).then(response => {
                this.releases = response.data;
            });
        },

        getParentTicketList() {
            let params = `?release_id=${this.data.release_id}`;
            Vue.$ticketService.getParentTicketList(params).then(response => {
                this.parentTickets = response.data;
            });
        },

        getAppList() {
            Vue.$appService.appList().then((response)=>{
                this.apps = response
                if(this.referrer!==''){
                    let referrer = this.referrer
                    let app = _.find(this.apps,(value)=>{
                        return referrer.includes(value.referrer)
                    })
                    if(app){
                        this.data.app_id = app.id
                    }
                }
                if(this.point) {
                    this.data.app_id = this.point.attributes.app_id
                }
                if(this.apps.length===1){
                    this.data.app_id = this.apps[0].id
                }
                this.loading = false;
            })
        },

        viewParent() {
            this.$router.push({
                name: "tickets.edit",
                params: {
                    id: this.data.ticket_parent_id
                }
            });
        },

        viewRelease() {
            this.$router.push({
                name: "releases.edit",
                params: {
                    id: this.data.release_id
                }
            });
        },
        getTags(){
            Vue.$tagService.getList('?filter=user_tag').then((response)=>{
                this.tags=response.data
            })
        },
        getFilteredTags(text){
            this.filteredTags = this.tags.filter(element=>{
                return element.attributes.value.includes(text)
            })
        },
        upload(files){
            this.files = files
        }
    }
};
</script>